import React from 'react';

export const CaretUp: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width || '1em'} height={height || '1em'} viewBox="0 0 128 128">
        <path fill={color || 'currentColor'} d="M114.4,95.34,65.81,46.75a2.56,2.56,0,0,0-3.62,0L13.6,95.34a2.56,2.56,0,0,1-3.65,0L6.59,91.81a2.56,2.56,0,0,1,0-3.58L62.19,32.66a2.58,2.58,0,0,1,3.62,0l55.57,55.57a2.56,2.56,0,0,1,0,3.58l-3.36,3.49A2.56,2.56,0,0,1,114.4,95.34Z"/>
    </svg>
);
